/* eslint-disable */
// prettier-ignore
import axios, { type AxiosError, type AxiosResponse } from 'axios'
import { notification } from 'antd'
// import store from '../Store/store'
// import { setLoginState } from '../Reducer/AuthReducer'
import handleError from './AxiosResponceStatus'
import { pageReloadAuth } from '../Reducer/AuthReducer'
import { AutoLogoutwithoutTime } from '../Utils/AutomaticLogout'
// import { useNavigate } from 'react-router-dom'

type NotificationType = 'success' | 'error' | 'info' | 'warning'
interface ErrorResponse {
    statusCode: number
    identifierId: number
    operationMsg: string
    data: any | null
    error: any | null
}
const showNotification = (
    type: NotificationType,
    message: string,
    description: string
): void => {
    notification[type]({
        message,
        description,
    })
}
const checkLocalNetwork = (): boolean => {
    return navigator.onLine
}
// const pendingRequests = new Map<string, AbortController>()

// const generateRequestKey = (config: any): string => {
//     const { method, url, params, data } = config
//     return `${method}:${url}:${JSON.stringify(params)}:${JSON.stringify(data)}`
// }

const instance = axios.create({
    // In development, use relative URLs so the proxy middleware handles them
    // In production, use the absolute URL from the environment variable
    baseURL:
        process.env.NODE_ENV === 'development'
            ? ''
            : process.env.REACT_APP_BASE_URL,
    // timeout: 7000,
})

// const isServerActive = true
instance.interceptors.request.use(
    async (config) => {
        // 1. Check network connection first
        if (!checkLocalNetwork()) {
        } else {
            // const requestKey = generateRequestKey(config)

            // if (pendingRequests.has(requestKey)) {
            //     // Block the duplicate
            //     return Promise.reject(new Error('Duplicate request blocked.'))
            // }

            // const controller = new AbortController()
            // config.signal = controller.signal

            // pendingRequests.set(requestKey, controller) // <- ✅ semicolon here
            // ;(config as any)._requestKey = requestKey // <- ✅ now this line works

            const token = localStorage.getItem('jwtToken')
            if (token !== null) {
                config.headers.Authorization = `Bearer ${token}`
            }
        }
        return config
    },
    async (error) => {
        showNotification('error', 'Request Error', 'Error sending request.')
        return await Promise.reject(error)
    }
)
// const navigate = useNavigate()
instance.interceptors.response.use(
    async (response: AxiosResponse) => {
        // const requestKey = (response.config as any)._requestKey
        // if (requestKey) {
        //     pendingRequests.delete(requestKey)
        // }
        return response
    },
    async (error: AxiosError) => {
        // const requestKey = (error.config as any)?._requestKey
        // if (requestKey) {
        //     pendingRequests.delete(requestKey)
        // }
        const errorData = error.response?.data as ErrorResponse

        const url = error.request.responseURL
        // 1. Handle client-side network issues
        if (!checkLocalNetwork()) {
            // When the client has lost connection during the request
            showNotification(
                'error',
                '',
                'You have lost your internet connection. Please reconnect and try again.'
            )
        } else if (
            !url.includes('Authenticate') &&
            error.response?.status === 401
        ) {
            AutoLogoutwithoutTime()
        }
        // 2. Handle server response errors (like 404, 500)
        else if (
            !url.includes('SetSignatureNonTemplate') &&
            errorData?.operationMsg !== undefined &&
            errorData?.operationMsg !== null &&
            errorData?.operationMsg !== ''
        ) {
            showNotification('error', '', errorData?.operationMsg)
        } else if (
            !url.includes('SetSignatureNonTemplate') &&
            error.response?.status !== undefined &&
            error.response?.status !== null
        ) {
            showNotification('error', '', handleError(error.response.status))
        }
        // 3. Handle request timeout errors
        else if (error.code === 'ECONNABORTED') {
            showNotification(
                'error',
                '',
                'The request took too long to process. Please try again later.'
            )
        }
        // 4. Handle general network errors
        else if (error.message.includes('Network Error')) {
            showNotification(
                'error',
                '',
                'There was a network issue during the request. Please check your connection and try again.'
            )
        }
        // 5. Handle all other errors
        else {
        }

        // Always reject the error so that the calling function knows the request failed
        return await Promise.reject(error)
    }
)
export default instance
